export const form = {
  addField: "Ajouter un champ",
  addGroup: "Ajouter un groupe",
  addSeveritySection: "Ajouter la section de sévérité",
  copyGroup: "Copier le groupe",
  cloneSuffix: "(copie)",
  deleteGroup: "Supprimer le groupe",
  editGroup: "Modifier le groupe",
  error: {
    groupAlreadyExists:
      "Le groupe existe déjà, veuillez renseigner un nouveau nom.",
    invalid: "Il y a des erreurs dans le formulaire.",
    genericError: "Une erreur s'est produite",
  },
  expression: {
    calculation_detail: "Détail du calcul",
  },
  formEditor: "Éditeur de formulaire",
  jsonEditor: "Éditeur de JSON",
  maxChar: "Limite de caractères",
  preview: "Aperçu",
  severityGrid: {
    groupName: "Sévérité",
  },
  staticField: {
    component: {
      label: "Composante",
      placeholder: "Choisir la composante",
      mainLevelSample: "Composante",
      subLevelSample: "Sous composante",
    },
    material: {
      label: "Matériau",
      placeholder: "Choisir le matériau du défaut",
    },
    defect: {
      label: "Défaut",
      placeholder: "Choisir un défaut",
      dynamicValues: "Les choix disponibles dépendent du matériau…",
    },
    defectSuggestion: {
      label: "Suggestions :",
      placeholder: "Choisir un défaut suggéré",
      confidence: "confiance",
      warning: "a un taux de confiance de seulement",
      decisionTool: "Outil d'aide à la décision",
      decisionToolHelp: "Aide",
      error: {
        noSuggestionFound: "Aucune suggestion trouvée.",
        materialNotSupported:
          "Ne peut pas inférer des suggestions, matériau non supporté.",
        noImage:
          "Ne peut pas inférer des suggestions, pas d'image liée à l'observation.",
      },
      hideSaliencyMap: "Cacher la carte de saillance",
      showSaliencyMap: "Afficher la carte de saillance",
    },
    severity: {
      label: "Sévérité",
      placeholder: "Chosisir une sévérité",
      dynamicValues: "Les choix disponibles dépendent du défaut…",
      formEditorSample: {
        name: "Niveau {{level}}",
        description:
          "Ceci est la longue description du niveau {{level}}. Elle donne plus de précision sur le niveau {{level}} et son usage, afin renseigner le formulaire de manière optimale.",
        descriptionForDisabled:
          "Le niveau {{level}} est désactivé. Cela peut arriver lorsqu'on veut restreindre les choix possibles pour un défaut dans une grille de sévérité.",
      },
      levels: {
        1: "Bon",
        2: "Faible",
        3: "Modéré",
        4: "Sévère",
        5: "Très sévère",
      },
      disabledLevel:
        "Critère non disponible pour la combinaison de matériau et de défaut sélectionnée.",
    },
    probability: {
      label: "Probabilité de la défaillance",
      placeholder: "Choisir une probabilité",
      levels: {
        1: "Rare",
        2: "Improbable",
        3: "Possible",
        4: "Probable",
        5: "Presque certain",
      },
    },
    consequence: {
      label: "Conséquence de la défaillance",
      placeholder: "Choisir une conséquence",
      levels: {
        1: "Mineur",
        2: "Moyen",
        3: "Sérieux",
        4: "Majeur",
        5: "Catastrophique",
      },
    },
    risk: {
      label: "Risque",
      placeholder: "Choisir un risque",
      levels: {
        1: "Faible",
        2: "Moyen",
        3: "Élevé",
        4: "Très élevé",
        5: "Critique",
      },
    },
  },
  severityGridEditor: {
    title: "Grille de sévérité",
    steps: {
      defectTreeEditor: "Arbre de défauts",
      translation: "Traductions des composants",
      severityGridsListTable: "Liste des grilles de sévérité",
    },
  },
  templateEditor: "Éditeur de template",
  values: "Choix",
  validateMessages: {
    required: "Le champ est obligatoire",
    string: {
      max: "La taille du champ doit être au maximum de ${max} caractères",
    },
  },
  components: {
    placeholder: "Choisir une composante",
    placeholderSubcomponent: "Choisir une sous-composante",
  },
  choicesDialog: {
    title: "Choisir parmi les {{count}} valeurs suivantes :",
  },
};
